module.exports = __webpack_public_path__ + "img/637@2x.3bf8921c.png";